import { ASTER_PURCHASE_TYPES, ONE_ASTER_CATEGORY } from '../../Utility/constants';
import { convertTimeFormat, convertDateToServer, convertDateTimeFormat } from '@common/Utility/date-utils';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import Smartlook from 'smartlook-client';
import moment from 'moment';
import { getBookingType } from '@common/Utility/common-utils';
import { MY_ASTER_CATEGORY, PAGE_TYPE } from '@common/Constants/analytics';
import { dataLayerSendEvent } from '@common/Utility/analytics-utils';

export const dataLayerQuickBook = (name, data, extraParam) => {
  if (name === 'Quick Booking 1') {
    const eventPrams = {
      referrerpage: data.comingFrom,
      Speciality: data.speciality,
      apptype: data.consultationType,
      payment: data.typeOfPayment,
      insuranceProvider: data?.typeOfPayment === 'Insurance' ? data?.insuranceProvider : 'N/A',
      page_name: 'Quick Booking Screen',
    };
    dataLayerSendEvent(name, eventPrams);
    sendEventToSmartLook('quick_booking_step_1', name);
  } else if (name === 'Quick Booking 2') {
    const eventParams = {
      drname: data?.participant?.find((x) => x.actor.type === 'Practitioner')?.actor?.display,
      page_name: 'Quick Booking Doctor Screen',
      apptype: data?.extension?.find((x) => x.url === 'appointmentMode')?.valueString,
      speciality: extraParam,
      payment: data?.extension?.find((x) => x.url === 'payerType')?.valueString,
    };
    dataLayerSendEvent(name, eventParams);
    sendEventToSmartLook('quick_booking_step_2', name);
  } else if (name === 'Quick Booking 3') {
    const eventParams = {
      booking_id: data?.extension?.find((x) => x?.url === 'hisSystem')?.valueIdentifier?.value,
      appointment_date: convertDateTimeFormat(data?.start),
      apptDate: convertDateToServer(data?.start),
      facilityName: data?.participant?.find((x) => x.actor.type === 'Location')?.actor?.display,
      visitType: data?.extension?.find((x) => x?.url === 'visitParticulars')?.valueString,
      Speciality: data?.extension?.find((itm) => itm?.url === 'practitionerDepartment')?.valueString,
      insuranceProvider:
        data?.extension?.find((x) => x?.url === 'payerType')?.valueString === 'Insurance'
          ? data?.extension?.find((x) => x?.url === 'insuranceName')?.valueString
          : 'N/A', // need to work on same
      payment: data?.extension?.find((x) => x?.url === 'payerType')?.valueString,
      payment_amount:
        data?.extension?.find((x) => x?.url === 'paymentAmount')?.valueString === '-'
          ? 0
          : Number(data?.extension?.find((x) => x?.url === 'paymentAmount')?.valueString),
      apptype: data?.extension?.find((x) => x?.url === 'appointmentMode')?.valueString,
      payment_type: extraParam,
      page_name: 'Quick Booking Payment Screen',
      facility_type: data?.participant
        ?.find((x) => x.actor.type === 'Location')
        ?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString,
    };
    dataLayerSendEvent(name, eventParams);
    sendEventToSmartLook('quick_booking_step_3', name);
  }
};

export const dataLayerBook = (name, data, extraParam, referrer, isFromInstantGP = false) => {
  //   console.log('Data GA ', data, 'Dr name data GA', extraParam);
  // copay_amount: 30 AED
  if (name === 'Book Appointment') {
    const eventParams = {
      screen_name: 'Doctor Detail Screen',
      doctor_name: data?.participant?.find((x) => x.actor.type === 'Practitioner')?.actor?.display,
      speciality: data?.extension?.find((x) => x?.url === 'practitionerDepartment')?.valueString,
      appointment_mode: data?.extension?.find((x) => x?.url === 'appointmentMode')?.valueString,
      appointment_date: convertDateToServer(data?.start),
      appointment_time: convertTimeFormat(data?.start),
      hospital_name: data?.participant?.find((x) => x.actor.type === 'Location')?.actor?.display,
      referrerpage: referrer !== undefined && referrer !== null ? referrer : '',
      date_time: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      distance: data?.participant
        ?.find((x) => x.actor.type === 'Location')
        ?.actor?.extension?.find((itm) => itm?.url === 'distance')?.valueString,
      visit_Type: data?.extension?.find((x) => x?.url === 'visitParticulars')?.valueString,
      payment_amount:
        data?.extension?.find((x) => x?.url === 'paymentAmoun')?.valueString === '-'
          ? 0
          : Number(data?.extension?.find((x) => x?.url === 'paymentAmount')?.valueString),
      speciality_selected: data?.extension?.find((x) => x?.url === 'practitionerDepartment')?.valueString,
      pid: data?.participant?.find((x) => x.actor.type === 'Practitioner')?.actor?.reference,
      insurance_coverage: !!data?.extension?.find((x) => x?.url === 'insuranceCovered')?.valueBoolean,
    };
    dataLayerSendEvent(name, eventParams);
  } else if (name === 'Cancelled Appointment') {
    const eventParams = {
      booking_type:
        data?.extension?.find((x) => x?.url === 'appointmentCategory')?.valueString === 'quickBooking'
          ? 'Quick Booking'
          : 'Standard Booking',
      booking_id: data?.extension?.find((x) => x?.url === 'hisSystem')?.valueIdentifier?.value,
      drname: data?.participant?.find((x) => x.actor.type === 'Practitioner')?.actor?.display,
      Speciality: data?.participant
        ?.find((x) => x?.actor?.type === 'Practitioner')
        ?.actor?.extension?.find((itm) => itm?.url === 'practitionerDepartment')?.valueString,
      apptype:
        data?.extension?.find((x) => x?.url === 'appointmentMode')?.valueString === 'Online'
          ? 'Video Consultation'
          : 'In-Person Consultation',
      apptDate: convertDateToServer(data?.start),
      apptTime: convertTimeFormat(data?.start),
      insuranceProvider:
        data?.extension?.find((x) => x?.url === 'payerType')?.valueString === 'Insurance'
          ? data?.extension?.find((x) => x?.url === 'insuranceName')?.valueString
          : 'N/A',
      facilityName: data?.participant?.find((x) => x.actor.type === 'Location')?.actor?.display,
      payment: data?.extension?.find((x) => x?.url === 'payerType')?.valueString,
      paymentAmount: Number(data?.extension?.find((x) => x?.url === 'paymentAmount')?.valueString),
      distance: data?.participant
        ?.find((x) => x.actor.type === 'Location')
        ?.actor?.extension?.find((itm) => itm?.url === 'distance')?.valueString,
      paymentStatus:
        data?.extension?.find((x) => x?.url === 'paymentCompleted')?.valueString === 'true' ? 'Paid' : 'Unpaid',
      reason: extraParam,
      page_name: 'Cancelled Appointment Screen',
      facility_type: data?.participant
        ?.find((x) => x.actor.type === 'Location')
        ?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString,
      purchase_type: ASTER_PURCHASE_TYPES.DOCTOR,
      screen_name: 'Cancel Appointment',
      page_type: 'Cancel Appointment Page',
    };
    dataLayerSendEvent(name, eventParams);
  } else if (name === 'Reschedule Appointment') {
    const eventParams = {
      booking_type:
        data?.extension?.find((x) => x?.url === 'appointmentCategory')?.valueString === 'quickBooking'
          ? 'Quick Booking'
          : 'Standard Booking',
      drname: data?.participant?.find((x) => x.actor.type === 'Practitioner')?.actor?.display,
      Speciality: data?.participant
        ?.find((x) => x?.actor?.type === 'Practitioner')
        ?.actor?.extension?.find((itm) => itm?.url === 'practitionerDepartment')?.valueString,
      apptype:
        data?.extension?.find((x) => x?.url === 'appointmentMode')?.valueString === 'Online'
          ? 'Video Consultation'
          : 'In-Person Consultation',
      apptDate: convertDateToServer(data?.start),
      apptTime: convertTimeFormat(data?.start),
      newapptDate: convertDateToServer(extraParam),
      newapptTime: convertTimeFormat(extraParam),
      insuranceProvider:
        data?.extension?.find((x) => x?.url === 'payerType')?.valueString === 'Insurance'
          ? data?.extension?.find((x) => x?.url === 'insuranceName')?.valueString
          : 'N/A',
      facilityName: data?.participant?.find((x) => x.actor.type === 'Location')?.actor?.display,
      payment: data?.extension?.find((x) => x?.url === 'payerType')?.valueString,
      paymentAmount: Number(data?.extension?.find((x) => x?.url === 'paymentAmount')?.valueString),
      distance: data?.participant
        ?.find((x) => x.actor.type === 'Location')
        ?.actor?.extension?.find((itm) => itm?.url === 'distance')?.valueString,
      paymentStatus:
        data?.extension?.find((x) => x?.url === 'paymentCompleted')?.valueString === 'true' ? 'Paid' : 'Unpaid',
      page_name: 'Reschedule Screen',
      purchase_type: ASTER_PURCHASE_TYPES.DOCTOR,
      screen_name: 'Reschedule Appointment',
      page_type: 'Reschedule Appointment',
      booking_id: data?.extension?.find((x) => x?.url === 'hisSystem')?.valueIdentifier?.value,
    };
    dataLayerSendEvent(name, eventParams);
  } else if (name === 'Confirm Appointment') {
    const eventParams = {
      booking_id: data?.extension?.find((x) => x?.url === 'hisSystem')?.valueIdentifier?.value,
      booking_type: isFromInstantGP ? 'Instant GP' : 'Standard Booking',
      drname: data?.participant?.find((x) => x.actor.type === 'Practitioner')?.actor?.display,
      Speciality: isFromInstantGP
        ? 'General Medicine'
        : data?.extension?.find((x) => x?.url === 'practitionerDepartment')?.valueString,
      apptype: data?.extension?.find((x) => x?.url === 'appointmentMode')?.valueString,
      visitType: data?.extension?.find((x) => x?.url === 'visitParticulars')?.valueString,
      apptDate: convertDateToServer(data?.start),
      appointment_date: convertDateTimeFormat(data?.start),
      appointment_time: convertTimeFormat(data?.start),
      insuranceProvider:
        data?.extension?.find((x) => x?.url === 'payerType')?.valueString === 'Insurance'
          ? data?.extension?.find((x) => x?.url === 'insuranceName')?.valueString
          : 'N/A',
      hospital_name: data?.participant?.find((x) => x.actor.type === 'Location')?.actor?.display,
      payment: data?.extension?.find((x) => x?.url === 'payerType')?.valueString,
      payment_amount: Number(data?.extension?.find((x) => x?.url === 'paymentAmount')?.valueString),
      distance: data?.participant
        ?.find((x) => x.actor.type === 'Location')
        ?.actor?.extension?.find((itm) => itm?.url === 'distance')?.valueString,
      payment_type: extraParam,
      page_name: 'Checkout Screen',
      facility_type: data?.participant
        ?.find((x) => x.actor.type === 'Location')
        ?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString,
      referrer_page: referrer !== undefined && referrer !== null ? referrer : '',
      pid: data?.participant?.find((x) => x.actor.type === 'Practitioner')?.actor?.reference,
      speciality_selected: data?.extension?.find((x) => x?.url === 'practitionerDepartment')?.valueString,
      insurance_coverage: !!data?.extension?.find((x) => x?.url === 'insuranceCovered')?.valueBoolean,
    };
    dataLayerSendEvent(name, eventParams);
  }
};

export const dataLayerMenu = async (name, menu, screenName, clickedMenu, myAsterCategory, isFromHeader = false, ...rest) => {
  const eventParams = {
    clicked_menu: clickedMenu || name,
    location: menu,
    screen_name: screenName,
    myaster_category: myAsterCategory || ONE_ASTER_CATEGORY.CORE,
    ...(!isFromHeader ? { page_type: name } : {}),
  };
  dataLayerSendEvent('Menu_Click', eventParams);
  const properties = {
    type: name,
  };
  sendEventToSmartLook('menu_click', properties);
  if (name === 'Logout') {
    const eventParams = {
      logout: true,
    };
    dataLayerSendEvent('user_logged_out', eventParams);
    Smartlook.anonymize(true);
  }
};

export const dataLayerProfileManagementSuccess = (eventName, pageName) => {
  const eventParams = {
    page_name: pageName,
  };
  dataLayerSendEvent(eventName, eventParams);
};

export const dataLayerProfileUpdateSuccess = (screenName, pageType, referrerPage) => {
  const eventParams = {
    screen_name: screenName,
    page_type: pageType,
    myaster_category: MY_ASTER_CATEGORY?.ASCO,
    referrer_page: referrerPage,
  };
  dataLayerSendEvent('profile_update_success', eventParams);
};

export const dataLayerFamilyMembersEdit = (screenName, pageType, referrerPage)=>{
  const eventParams = {
    screen_name: screenName,
    page_type: pageType,
    myaster_category: MY_ASTER_CATEGORY?.ASCO,
    referrer_page: referrerPage,
  };
  dataLayerSendEvent('family_member_edit', eventParams);
};

export const dataLayerEditProfileError = (screenName, pageType, referrerPage, error, errType) => {
  const eventParams = {
    screen_name: screenName,
    page_type: pageType,
    myaster_category: MY_ASTER_CATEGORY?.ASCO,
    referrer_page: referrerPage,
    error: error,
    err_type: errType,
  };
  dataLayerSendEvent('edit_profile_error', eventParams);
};

export const dataLayerProfileManagementFailure = (eventName, pageName, error, doctorName, docID,docName) => {
  const data = {
    error: error,
  };

  if (eventName === 'add_family_member_error') {
    Object.assign(data, {
      screen_name: doctorName ? docName : 'add family members',
      page_type: doctorName ? PAGE_TYPE.DDP : PAGE_TYPE.PROFILE,
      myaster_category: doctorName ? MY_ASTER_CATEGORY?.DOCTOR_CONSULT : MY_ASTER_CATEGORY?.ASCO,
      ...(doctorName ? { page_id: docID } : {}),
    });
  }
  else {
    data.page_name = pageName;
  }
  dataLayerSendEvent(eventName, data);
};

export const dataLayerFromGuestToLogin = (event, page) => {
  const eventParams = {
    page_name: page,
  };
  dataLayerSendEvent(event, eventParams);
};

export const dataLayerFollowUpAppt = (data, event, pagename) => {
  const eventParams = {
    page_name: pagename,
    drname: data?.doctorName,
    Speciality: data?.doctorSpecialty,
    facilityName: data?.facilityName,
    apptype: data?.consultationType,
    apptId: data?.bookingConfirmationId,
    facility_type: data?.facilityType,
    appointment_date: data?.appointmentDate,
    appointment_time: data?.appointmentTime,
  };
  dataLayerSendEvent(event, eventParams);
};

export const dataLayerApptManagement = (apptData, event, pagename, purchasetype, pagetype) => {
  const eventParams = {
    page_name: pagename,
    drname: apptData.doctorName,
    Speciality: apptData.doctorType,
    facilityName: apptData?.address,
    apptype: pagename === 'Appointment List Screen' ? apptData?.consultType : apptData?.appointmentMode,
    apptId: apptData?.appointmentId,
    facility_type: apptData?.location?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString,
    appointment_date: apptData?.date,
    appointment_time: apptData?.time,
    purchase_type: purchasetype,
    page_type: pagetype,
  };
  dataLayerSendEvent(event, eventParams);
};

const getPaymentType = (data) => {
  if (data === 'Pay at Clinic') {
    return 'Pay at Clinic';
  } else {
    if (data?.isPaymentCardExists) {
      return 'SAVED CARD';
    } else {
      return 'Pay via Credit/Debit Card';
    }
  }
};

const sendPurchaseEvent = (data, detail) => {
  const eventParams = {
    booking_type: getBookingType(detail?.extension?.find((x) => x?.url === 'appointmentCategory')?.valueString),
    appointment_date: convertDateTimeFormat(detail?.start),
    doctor_name: detail?.participant?.find((x) => x.actor.type === 'Practitioner')?.actor?.display,
    speciality: detail?.participant
      ?.find((x) => x?.actor?.type === 'Practitioner')
      ?.actor?.extension?.find((itm) => itm?.url === 'practitionerDepartment')?.valueString,
    payment_method: detail?.extension?.find((x) => x?.url === 'payerType')?.valueString,
    insurance_provider:
      detail.extension?.find((x) => x?.url === 'payerType')?.valueString === 'Insurance'
        ? detail?.extension?.find((x) => x?.url === 'insuranceName')?.valueString
        : 'N/A',
    booking_id: detail?.extension?.find((x) => x?.url === 'hisSystem')?.valueIdentifier?.value,
    visit_Type: detail?.extension?.find((x) => x?.url === 'visitType')?.valueString,
    apptDate: convertDateToServer(detail?.start),
    facilityName: detail?.participant?.find((x) => x.actor.type === 'Location')?.actor?.display,
    distance: detail?.participant
      ?.find((x) => x.actor.type === 'Location')
      ?.actor?.extension?.find((itm) => itm?.url === 'distance')?.valueString,
    facility_type: detail?.participant
      ?.find((x) => x.actor.type === 'Location')
      ?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString,
    currency: detail?.extension?.find((x) => x?.url === 'currencyCode')?.valueString,
    value: Number(detail?.extension?.find((x) => x?.url === 'paymentAmount')?.valueString),
    transaction_id: detail?.id,
    appointment_mode:
      detail?.extension?.find((x) => x?.url === 'appointmentMode')?.valueString === 'Online'
        ? 'Video Consultation'
        : 'In-Person Consultation',
    purchase_type: ASTER_PURCHASE_TYPES.DOCTOR,
    payment_type: getPaymentType(data),
    secure_points_used: 'False',
    tax: 0,
    shipping: 0,
    loyalty_points_used: '',
    ecommerce: {
      items: [
        {
          item_id: detail?.participant?.find((x) => x.actor.type === 'Practitioner')?.actor?.reference,
          item_name: detail?.participant?.find((x) => x.actor.type === 'Practitioner')?.actor?.display,
          coupon: '',
          currency: detail?.extension?.find((x) => x?.url === 'currencyCode')?.valueString,
          discount: '',
          index: '',
          item_brand: '',
          item_category: detail?.participant
            ?.find((x) => x?.actor?.type === 'Practitioner')
            ?.actor?.extension?.find((itm) => itm?.url === 'practitionerDepartment')?.valueString,
          item_list_id: detail?.participant?.find((x) => x.actor.type === 'Location')?.actor?.reference,
          item_list_name: detail?.participant?.find((x) => x.actor.type === 'Location')?.actor?.display,
          price: Number(detail?.extension?.find((x) => x?.url === 'netPrice')?.valueString),
          quantity: 1,
        },
      ],
    },
  };
  dataLayerSendEvent('purchase', eventParams);
  const properties = {
    type: 'purchase',
  };
  sendEventToSmartLook('purchase', properties);
};

export const dataLayerPayment = (data, detail) => {
  if (data === 'Pay at Clinic') {
    sendPurchaseEvent(data, detail);
  } else {
    const status = data?._embedded?.payment[0]?.state;
    if (status === 'CAPTURED' || status === 'AUTHORISED' || status === 'PARTIALLY_CAPTURED') {
      const eventParams = {
        paymentState: 'Success',
        currencyType: data?._embedded?.payment[0]?.amount?.currencyCode,
        payAmount: Number(data?._embedded?.payment[0]?.amount?.value) / 100,
      };
      dataLayerSendEvent('Payment Done', eventParams);
      sendPurchaseEvent(data, detail);
    } else if (status === 'FAILED') {
      const eventParams = {
        event: 'Payment Done',
        paymentState: 'Fail',
        currencyType: data?._embedded?.payment[0]?.amount?.currencyCode,
        payAmount: Number(data?._embedded?.payment[0]?.amount?.value) / 100,
      };
      dataLayerSendEvent('Payment Done', eventParams);
    }
  }
};

export const dataLayerSearch = (data, source, term, type, isGuest, screen) => {
  const eventParams = {
    source_of_search: source,
    search_category: type,
    search_term: term,
    search_selection: data,
    search_type: ONE_ASTER_CATEGORY.DOCTOR,
    user_state: !isGuest && isGuest !== undefined ? 'Logged In' : 'Guest',
    screen_name: screen,
    search_action_type: null,
    result_ids: null,
  };
  dataLayerSendEvent('search', eventParams);
  const properties = {
    type: source,
  };
  sendEventToSmartLook('search', properties);
};

export const dataLayerLogin = (name) => {
  dataLayerSendEvent(name, {});
};

export const dataLayerOrderRx = (pageName, pageType, details, medicationDetails={}) => {
  const eventParams = {
    screen_name: pageName,
    page_type: pageType,
    transaction_id: details?.transaction_id || medicationDetails?.[0]?.resource?.id, 
    booking_id: details?.booking_id,
    doctor_name: details?.doctor_name,
    appointment_mode: details?.consultation_type,
    speciality: details?.speciality,
    payment_method: details?.payment_method,
    payment_amount: details?.payment_amount,
    payment_status: details?.payment_status,
    facility_name: details?.hospital_name,
    facility_type: details?.facility_type,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,

  };
  dataLayerSendEvent('order_rx', eventParams);
};
